import React, { Component } from 'react';
import { GlassPage, GlassPanels, GlassPanel } from 'glass-core';
import { home_icon } from '@informatica/archipelago-icons';
import grids from './../../../assets/grid.png';
import services from './../../../assets/services.png';

class About extends Component {
  render() {
    return (
      <GlassPage name="About">
        <div style={{'marginBottom': '30px'}}>
          <h1>About Page</h1>
          <img src={services} alt="Services Icon from platform" />
          <img src={grids} alt="Services Icon from platform" />
        </div>
        <GlassPanels>
            <GlassPanel title="About page panel example" order="6" colSpan="6">
                This is a workspace. Similar to Home, this can also have contributable panels.
            </GlassPanel>
        </GlassPanels>
      </GlassPage>
    );
  }
}
About.workspaceConfig = {
  name: 'About',
  icon: home_icon,
  path: '/about',
  label: 'About',
  tooltip: '',
  component: About,
  type: 'fixed'
};

export default About;
